var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-echart',{staticClass:"graph-echart",attrs:{"id":"graph-echart","width":"80vw","height":"60vh","option":_vm.option},on:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }